document.addEventListener("DOMContentLoaded", () => {

    

    const subMenuToggles = document.querySelectorAll('.sub-menu-toggle');

    subMenuToggles.forEach(function (t) {
        t.addEventListener('click', function (e) {
            toggleNav(e);
        });
    });

    const desktopClickable = document.querySelectorAll('.desktop-clickable');

    desktopClickable.forEach(function (t) {
        t.addEventListener('click', function (e) {
            toggleNav(e);
        });
    });

    function toggleNav(e) {
        const closestParent = e.target.closest('.menu-item.menu-item-has-children');

        closestParent.classList.toggle('active');

        const siblings = Array.from(closestParent.parentNode.childNodes).filter(function(node) {
            return node.nodeType === 1 && node !== closestParent;
        });

        siblings.forEach(function(sibling) {
            const item = sibling.closest('.menu-item.menu-item-has-children');

            if (!item) return;

            if (sibling.tagName === 'LI' && item.classList.contains('active')) {
                sibling.closest('.menu-item.menu-item-has-children').classList.remove('active');
            }
        });
    }

    const siteMain = document.querySelector('.site-main');
    const sections = document.querySelectorAll('section');
    const menuItems = document.querySelectorAll('.menu-item');

    if (siteMain) {
        siteMain.addEventListener('click', function () {
            menuItems.forEach(function (menuItem) {
                menuItem.classList.remove('active');
            });
        });
    }

    document.body.addEventListener('click', function(e) {
        if (!e.target.closest('header')) {
            menuItems.forEach(function (menuItem) {
                menuItem.classList.remove('active');
            });
        }
    });
    
    // document.addEventListener("scroll", () => {
    //     menuItems.forEach(function (menuItem) {
    //         //menuItem.classList.remove('active');
    //     });
    // });

});